export default class ConsoleWebConfig {
  readonly serviceMessageCode: number

  constructor(serviceMessageCode: number = 0) {
    this.serviceMessageCode = serviceMessageCode
  }
}
